import { ListenModeHighlightDecorator } from "./ListenModeHighlightDecorator";

export * from "./ListenModeHighlightDecorator";

export default ListenModeHighlightDecorator;
